export const CLOSED = 'CLOSED';
export const RESTORED = 'RESTORED';
export const MINIMIZED = 'MINIMIZED';
export const MAXIMIZED = 'MAXIMIZED';
